export default {
    scrollOffset: 60,
    userSettingsDrawer: false,
    error: null,
    notification: {}
}